import { EnvsNamesMap } from '@/constants';

export default {
  SERVER_URL: 'https://prices.stage.rhapsody.vet/api',
  API_URL: 'https://prices.stage.rhapsody.vet/api/api',
  AUTH_URL: 'https://prices.stage.rhapsody.vet/api/auth',
  ENV: EnvsNamesMap.STAGE
};
